// extracted by mini-css-extract-plugin
module.exports = {"popup":"ConfirmPopup-module__popup"};